var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.508c0 .897.17 1.74.51 2.526.338.787.81 1.48 1.413 2.077a6.616 6.616 0 0 0 2.093 1.401 6.452 6.452 0 0 0 2.546.505 6.35 6.35 0 0 0 1.982-.306 6.628 6.628 0 0 0 1.728-.854l3.87 3.84c.104.104.225.18.362.23.137.049.278.073.422.073.21 0 .394-.047.555-.141a1.03 1.03 0 0 0 .38-.385c.093-.162.139-.346.139-.553a1.089 1.089 0 0 0-.306-.76l-3.842-3.821a6.44 6.44 0 0 0 .942-1.778c.226-.65.339-1.335.339-2.054 0-.897-.17-1.739-.51-2.526A6.503 6.503 0 0 0 11.21 1.91a6.702 6.702 0 0 0-2.093-1.4A6.427 6.427 0 0 0 6.562 0a6.41 6.41 0 0 0-2.546.508 6.702 6.702 0 0 0-2.093 1.4A6.498 6.498 0 0 0 .509 3.983C.17 4.77 0 5.612 0 6.508zm1.566 0c0-.684.129-1.326.388-1.924a4.948 4.948 0 0 1 1.078-1.577c.46-.453.991-.808 1.592-1.064a4.898 4.898 0 0 1 1.938-.384c.691 0 1.338.128 1.942.384a5.027 5.027 0 0 1 2.667 2.641c.258.598.388 1.24.388 1.924 0 .684-.13 1.325-.388 1.924a4.975 4.975 0 0 1-1.075 1.577 5.034 5.034 0 0 1-1.592 1.064 4.92 4.92 0 0 1-1.942.384 4.894 4.894 0 0 1-1.938-.384 5.093 5.093 0 0 1-1.592-1.064 4.943 4.943 0 0 1-1.078-1.577 4.797 4.797 0 0 1-.388-1.924z",
    fill: "#00000050",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlackIcon);
export default __webpack_public_path__ + "static/media/search-black-icon.aa128525.svg";
export { ForwardRef as ReactComponent };